// @ts-nocheck
/* eslint-disable func-names */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/named */
import { takeLatest, spawn, put } from 'redux-saga/effects';

import apiRequest, { apiSuccess } from 'utils/api';
import { truthty } from 'utils/functions';
import { appActions } from 'commons/reducer';
import { CLIENTS } from '../reducer';

function* getStateFromApi() {
  yield takeLatest(CLIENTS.GET_STATE_FROM_API, function* (action) {
    const response = yield apiRequest('api/v1/clients', { method: 'get' });
    yield put(apiSuccess(CLIENTS.GET_STATE_FROM_API_SUCCESS, response));
  });
}

function* createClient() {
  yield takeLatest(CLIENTS.CREATE_CLIENT, function* (action) {
    yield put(appActions.setLoader('create-edit-client', true));
    const response = yield apiRequest('api/v1/clients', {
      method: 'post',
      body: JSON.stringify(action.controls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(CLIENTS.CREATE_CLIENT_SUCCESS, response));
    }
    yield put(appActions.setLoader('create-edit-client', false));
  });
}

function* editClient() {
  yield takeLatest(CLIENTS.EDIT_CLIENT, function* (action) {
    yield put(appActions.setLoader('create-edit-client', true));
    const response = yield apiRequest(`api/v1/clients/${action.id}`, {
      method: 'put',
      body: JSON.stringify(action.controls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(CLIENTS.EDIT_CLIENT_SUCCESS, response));
    }
    yield put(appActions.setLoader('create-edit-client', false));
  });
}

function* deleteClient() {
  yield takeLatest(CLIENTS.DELETE_CLIENT, function* (action) {
    yield put(appActions.setLoader('delete-client', true));
    const response = yield apiRequest(`api/v1/clients/${action.id}`, { method: 'delete' });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    }
    const item = Object.values(response)[0];
    yield put(apiSuccess(CLIENTS.DELETE_CLIENT_SUCCESS, { item, type: 'clients' }));
    yield put(appActions.setLoader('delete-client', false));
  });
}

function* exportClients() {
  yield takeLatest(CLIENTS.EXPORT_CLIENT, function* (action) {
    yield put(appActions.setLoader('export-clients', true));
    const response = yield apiRequest(
      'api/v1/clients/export',
      { method: 'get' },
      false,
      'clients.xlsx',
    );
    yield put(apiSuccess(CLIENTS.EXPORT_CLIENT_SUCCESS, response));
    yield put(appActions.setLoader('export-clients', false));
  });
}

function* importClients() {
  yield takeLatest(CLIENTS.IMPORT_CLIENTS, function* (action) {
    yield put(appActions.setLoader('import-clients', true));
    yield put(
      appActions.showImportModal({
        title: 'Importando Clientes',
      }),
    );
    try {
      const tenant = window.location.hostname.split('.')[0];
      const formData = new FormData();
      formData.append('file', action.payload.file);
      formData.append('type', action.payload.type);
      formData.append('socketId', action.payload.socketId);
      formData.append('tenant', tenant);
      const response = yield apiRequest('api/v1/clients/import', {
        method: 'post',
        body: formData,
      });
      if (truthty(response.error)) {
        yield put({ type: CLIENTS.IMPORT_CLIENTS_ERROR, payload: response.errorMsg });
        yield put(appActions.setError(response.errorMsg));
      } else {
        yield put({ type: CLIENTS.IMPORT_CLIENTS_SUCCESS, payload: response });
        yield put({
          type: CLIENTS.IMPORT_CLIENTS_STARTED,
          payload: { jobId: response.jobId },
        });
      }
    } catch (error) {
      yield put({
        type: CLIENTS.IMPORT_CLIENTS_ERROR,
        payload: 'Error al iniciar importación 3',
      });
    }
  });
}

function* handleImportSocketResponse() {
  yield takeEvery(
    [CLIENTS.IMPORT_CLIENTS_SOCKET_SUCCESS, CLIENTS.IMPORT_CLIENTS_SOCKET_ERROR],
    function* (action) {
      yield put(appActions.setLoader('import-clients', false));
      if (action.type === CLIENTS.IMPORT_CLIENTS_SOCKET_SUCCESS) {
        yield put({ type: CLIENTS.GET_STATE_FROM_API });
        const result = action.payload.importResult;
        const processedCount = result?.processed || 'varios';
        yield put(appActions.setSuccess(` ${processedCount} clientes procesados exitosamente`));
      } else if (action.type === CLIENTS.IMPORT_CLIENTS_SOCKET_ERROR) {
        const errorMsg = action.payload.error || 'Error desconocido en la importación';
        yield put(appActions.setError(` ${errorMsg}`));
      }
    },
  );
}

export default function* saga() {
  yield spawn(getStateFromApi);
  yield spawn(deleteClient);
  yield spawn(createClient);
  yield spawn(editClient);
  yield spawn(exportClients);
  yield spawn(importClients);
  yield spawn(handleImportSocketResponse);
}
